import { render, staticRenderFns } from "./cqWu.vue?vue&type=template&id=08b879b5"
import script from "./cqWu.vue?vue&type=script&lang=js"
export * from "./cqWu.vue?vue&type=script&lang=js"
import style0 from "./cqWu.vue?vue&type=style&index=0&id=08b879b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports